import React from 'react'
import styled from 'styled-components'

interface Props {
	size: number
	isFilled: boolean
	onClick?: () => void
	onMouseEnter?: () => void
	onMouseLeave?: () => void
	isInteractive?: boolean
}

const RatingStar: React.FC<Props> = ({ size, isFilled, onClick, onMouseEnter, onMouseLeave, isInteractive }) => {
	return (
		<StarContainer
			size={size}
			onClick={onClick}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			$isInteractive={isInteractive ?? false}
		>
			<svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
					fill={isFilled ? 'var(--primary-color)' : 'var(--sub-text-color)'}
					style={{ transition: 'fill 0.15s ease' }}
				/>
			</svg>
		</StarContainer>
	)
}

interface StarContainerProps {
	size: number
	$isInteractive: boolean
}

const StarContainer = styled.div<StarContainerProps>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: ${({ $isInteractive }) => ($isInteractive ? 'pointer' : 'default')};
	padding: 2px;
	transition: transform 0.15s ease;

	${({ $isInteractive }) =>
		$isInteractive &&
		`
		&:hover {
			transform: scale(1.15);
		}
		&:active {
			transform: scale(0.95);
		}
	`}
`

export default RatingStar
